const formations = [
  {
    label: "Marketing digital & data",
    value: "Marketing digital & data"
  },
  {
    label: "Influence & réseaux sociaux",
    value: "Influence & réseaux sociaux"
  },
  {
    label: "Communication & brand content",
    value: "Communication & brand content"
  },
  {
    label: "Événementiel & relations presse",
    value: "Événementiel & relations presse"
  },
  {
    label: "E-commerce & retail marketing",
    value: "E-commerce & retail marketing"
  },
  {
    label: "Je ne sais pas encore",
    value: "Je ne sais pas encore"
  }
]



export default formations
